import type { MonitoringShipmentDriverEntity } from '@/features/driver/domain/entities/MonitoringShipmentDriverEntity'
import type { JobStatus } from '@/features/job/domain/enums/JobStatus'
import type { ShipmentLiveEntity } from './ShipmentLiveEntity'
import type { MonitoringShipmentBranchEntity } from '@/features/branch/domain/entities/MonitoringShipmentBranchEntity'
export class JobLiveEntity {
  createdAt?: string
  branch?: MonitoringShipmentBranchEntity
  driver?: MonitoringShipmentDriverEntity
  jobId?: string
  jobStatus?: JobStatus
  shipments?: Array<ShipmentLiveEntity>
  isNew?: boolean
  inRearrangement?: boolean
  location?: {
    latitude: number
    longitude: number
  }
}
